import React, { useEffect, useMemo, useState } from 'react'
import {
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Switch,
  TimePicker,
} from 'antd'
import { EventResp } from 'types/event/events'
import { eventShatStore } from 'state/event/eventChat'
import {
  useDeleteScheduledMessage,
  useGetScheduleMessageById,
  useUpdateScheduledMessage,
} from 'api/Contact/Contact'
import moment from 'moment'
import Spinner from 'components/Spinner'
import RecepientInput from './RecepientInput'
import { infoMessage } from 'api/global'
import { SendSmsPayload } from 'types/chat'
import { myStore } from 'state/store'

interface ShowScheduleContentProps {
  form: FormInstance
  eventData: EventResp
}

const ShowScheduleContent: React.FC<ShowScheduleContentProps> = ({
  form,
  eventData,
}) => {
  const [isScheduled, setIsScheduled] = useState<boolean>(true)
  const {
    setScheduleModalVisible,
    scheduleForId,
    selectedParticipants,
    setSelectedParticipants,
  } = eventShatStore(store => ({
    setScheduleModalVisible: store.setScheduleModalVisible,
    scheduleForId: store.scheduleForId,
    selectedParticipants: store.selectedParticipants,
    setSelectedParticipants: store.setSelectedParticipants,
  }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const { data, isLoading, isFetching, refetch } =
    useGetScheduleMessageById(scheduleForId)
  const { mutate: updateScheduledMessage } = useUpdateScheduledMessage()

  const formSchema = {
    message: data ? data.smsText : '',
    scheduleDate: data ? moment(data.scheduledAt) : undefined,
    scheduleTime: data ? moment(data.scheduledAt) : undefined,
  }

  const handleFinish = (values: any) => {
    if (selectedParticipants.length === 0)
      return infoMessage('Please select attendees')
    const payload: SendSmsPayload = {
      attendeesIds: selectedParticipants,
      text: values.message,
      scheduledAt: isScheduled
        ? moment
            .utc(
              `${moment(values.scheduleDate).format('YYYY-MM-DD')} ${moment
                .utc(values.scheduleTime)
                .format('HH:mm')}`,
            )
            .format()
        : undefined,
    }
    setModalBtnLoader(true)
    updateScheduledMessage(
      { payload, smsId: scheduleForId },
      {
        onSuccess: () => {
          setModalBtnLoader(false)
          setScheduleModalVisible(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }

  useEffect(() => {
    if (data) {
      console.log(data, 'data of attendee')
    }
  }, [data])

  useMemo(() => {
    if (data) {
      setSelectedParticipants(data.attendeeIds ?? [])
    }
  }, [data])

  useEffect(() => {
    if (scheduleForId) {
      refetch()
    }
  }, [scheduleForId])
  return (
    <>
      {isLoading || isFetching ? (
        <div className="flex align-center justify-center py-40px">
          <Spinner />
        </div>
      ) : (
        <Form
          form={form}
          layout="vertical"
          initialValues={formSchema}
          onFinish={handleFinish}
        >
          <RecepientInput eventData={eventData} contactType={'sms'} />
          <Row className="mt-10px">
            <Col>
              <Form.Item className="form-control mb-0 mt-15px" name="message">
                <Input.TextArea
                  className="note-field"
                  placeholder="Your message..."
                  autoSize={{ minRows: 5, maxRows: 10 }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-20px">
            <Col span={24} className="flex align-center justify-between ">
              <label className="input-label">Scheduled At:</label>
              <Switch onChange={() => setIsScheduled(prev => !prev)} />
            </Col>
            {isScheduled && (
              <Col span={24}>
                <Row gutter={24} className="mt-15px">
                  <Col span={12}>
                    <Form.Item
                      name="scheduleDate"
                      rules={[{ required: true, message: 'Date is required' }]}
                    >
                      <DatePicker
                        className="w-100 form-control-field"
                        placeholder="Select date"
                        disabledDate={current =>
                          current && current.date() < new Date().getDate()
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="scheduleTime"
                      rules={[{ required: true, message: 'Time is required' }]}
                    >
                      <TimePicker
                        className="w-100 form-control-field"
                        placeholder="Start Time"
                        format="h:mm a"
                        showNow={false}
                        clearIcon={false}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Form>
      )}
    </>
  )
}

export default ShowScheduleContent
